import PropTypes from "prop-types";
import { useTrimOnChange } from "~/hooks/useTrimOnChange";
import { Input } from "~/components/Base/Input/Input";
import { ReadOnlyText } from "~/components/Base/ReadOnlyText/ReadOnlyText";

export function SingleLineText({
  ariaDescribedBy,
  label,
  oid,
  onChange,
  readOnly,
  valid,
  value,
}) {
  const { trimAll, trimStart } = useTrimOnChange(onChange);

  if (readOnly) {
    return (
      <ReadOnlyText
        id={oid}
        ariaLabel={label}
        value={value}
      />
    );
  }

  return (
    <Input
      ariaDescribedBy={ariaDescribedBy}
      ariaLabel={label}
      fullWidth
      id={oid}
      onBlur={trimAll}
      onChange={trimStart}
      valid={valid}
      value={value}
    />
  );
}

SingleLineText.propTypes = {
  ariaDescribedBy: PropTypes.string,
  label: PropTypes.string,
  oid: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  valid: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
